module.exports = __webpack_public_path__ + "img/passport-fin-old.00d03853.png";